/**
 * Aviso azul "Importante:" das confirmações de plano — o mesmo bloco na troca
 * de plano e na assinatura feita durante o período de teste.
 */
import type { ReactNode } from 'react';
import { Clock } from 'lucide-react';

export function ImportantNotice({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3 text-sm text-blue-800 dark:text-blue-200">
      <p className="flex items-start gap-2">
        <Clock className="h-4 w-4 mt-0.5 flex-shrink-0" />
        <span>
          <strong>Importante:</strong> {children}
        </span>
      </p>
    </div>
  );
}

export default ImportantNotice;
